module.exports = __webpack_public_path__ + "static/img/vipstep.0214533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FLVersion/vipstep.png
// module id = Oz94
// module chunks = 0